import { notify } from 'app/services/errorReporter';

/**
 * Returns a validator function, that checks if the given key is included in Storage
 *
 * @param {Record} Storage All valid keys (keys not included here are invalid, and will throw later)
 */
export const validateKey = (Storage) => (key, context) => {
  if (!Storage.has(key)) {
    const error = new Error('Tried to use an invalid storage key');
    notify(error, {
      name: 'Storage.invalidKey',
      context,
    });
    throw error;
  }
};
